// import { getDataFromSSR } from "@/handlers/client/commonClient";
import { useWindowSize } from "@/hooks/useIsMobile";
//import Link from "next/link";
// import { logger } from "@/utils/logging/log-util";
import dynamic from "next/dynamic";
import SVG from "react-inlinesvg";
import { stateLangMapper, stateLinkMapper } from "@/utils/langCodeMapper";
// import Head from "next/head";
import { useEffect } from "react";
import { useRouter } from "next/router";
import GTMScript from "@/component/Ads/GTMScript";
const NoData = dynamic(() => import("@/component/NoData"));

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));

const Category = ({ categoryNewsListData = null, statesData = null }) => {


  const size = useWindowSize();
  const router = useRouter();

  useEffect(() => {

    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());
          categoryNewsListData &&
            Object?.keys(categoryNewsListData)?.length > 1 &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.enableServices();

          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());

          categoryNewsListData &&
            Object?.keys(categoryNewsListData)?.length > 1 &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.enableServices();
        });
      }
    }, 10);
  }, []);

  // useEffect(() => {
  //   const handleHashChange = () => {
  //     if (window.location.hash) {
  //       const id = window.location.hash.substring(1);
  //       const element = document.getElementById(id);
  //       if (element) {
  //         const elementPosition = element.getBoundingClientRect().top;
  //         const offsetPosition =
  //           elementPosition + (window.scrollY || window.pageYOffset) - 100;

  //         window.scrollTo({
  //           top: offsetPosition,
  //           behavior: "smooth",
  //         });
  //       }
  //     }
  //   };

  //   handleHashChange();

  //   window.addEventListener("hashchange", handleHashChange, false);

  //   return () => {
  //     window.removeEventListener("hashchange", handleHashChange, false);
  //   };
  // }, [router.asPath]);

  return (
    <section>
      <HeadTag
        title={"Latest States News | Breaking News on States"}
        description={
          "NewsTak provides you with the best compilation of all State News in India, Indian State News including politics (राजनीति न्यूज़), business (बिज़नेस न्यूज़) & more. Find out the top breaking news today in your region."
        }
        keywords={
          "States, News on States, stories on States, articles on States, States stories at States, States news, States latest news, today news, breaking news, news headlines, International news, National news, State news, India news, top news, political news, business news, राजनीति न्यूज़, बिज़नेस न्यूज़, इलेक्शन समाचार"
        }
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/state-news"}
        image={categoryNewsListData?.seo_detail?.og_image}
      // lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript />
      <BreadcrumbSchema
        breadcrumbList={[{ title: 'राज्य की खबरें', canonical_url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/state-news` }]}
      />
      <h1 className="sr-only">राज्य की खबरें</h1>
      <ItemsListSchema data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={[{ title: 'राज्य की खबरें', canonical_url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/state-news` }]} />
      {/* <VDOAdsScript /> */}

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />
        {categoryNewsListData && Object?.keys(categoryNewsListData)?.map((objKey, index) => {
          if (objKey && objKey !== "cache") {
            return size.width < 900 ? (
              <div id={objKey ?? index} className="scroll-margin-100">
                <List1
                  title={
                    objKey in stateLangMapper ? `${stateLangMapper[objKey]} की खबरें` : objKey
                  }
                  newsListData={categoryNewsListData[objKey]}
                  isLCP={true}
                  haveH1={false}
                  showAds={index === 0}
                />
                <a
                  className="flex justify-center items-center h-10 w-full my-4 border rounded-md border-gray-300 text-gray-500 hover:text-primary hover:bg-gray-100"
                  href={
                    objKey in stateLinkMapper ? stateLinkMapper[objKey] : "#"
                  }
                  target="_blank"
                >
                  <div className="flex justify-center items-center">
                    {`${objKey in stateLangMapper
                      ? stateLangMapper[objKey]
                      : objKey
                      } की सभी खबरें`}
                    <SVG
                      className="ml-2 h-4 w-4"
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.svg"
                    />
                  </div>
                </a>
              </div>
            ) : (
              <div id={objKey ?? index} className="scroll-margin-100">
                <List2
                  title={
                    objKey in stateLangMapper ? `${stateLangMapper[objKey]} की खबरें` : objKey
                  }
                  newsListData={categoryNewsListData[objKey]}
                  isLCP={true}
                  showAds={index === 0}
                  haveH1={false}
                />
                <a
                  className={`flex justify-center items-center h-10 w-full my-4 border rounded-md border-gray-300 text-gray-500 hover:text-primary hover:bg-gray-100`}
                  href={
                    objKey in stateLinkMapper ? stateLinkMapper[objKey] : "#"
                  }
                  target="_blank"
                >
                  <div className="flex justify-center items-center">
                    {`${objKey in stateLangMapper
                      ? stateLangMapper[objKey]
                      : objKey
                      } की सभी खबरें`}
                    <SVG
                      className="ml-2 h-4 w-4"
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.svg"
                    />
                  </div>
                </a>
              </div>
            );
          }
        })}

        {(statesData && statesData?.length) ? statesData?.map((obj, index) => {
          return size.width < 900 ? (
            <div id={index} className="scroll-margin-100">
              {obj?.title && <List1
                title={
                  `${obj?.title} की खबरें`
                }
                newsListData={obj?.content}
                isLCP={true}
                haveH1={false}
                showAds={index === 0}
              />}
              {obj?.title && <a
                className={`flex justify-center items-center h-10 w-full my-4 border rounded-md border-gray-300  
                    ${obj?.title.includes("मध्य प्रदेश") ? 'hover:text-mpDark' : obj?.title.includes("राजस्थान") ? 'hover:text-rajasthanDark' :
                    obj?.title.includes("हरियाणा") ? 'hover:text-hrDark' : obj?.title.includes("बिहार") ? 'hover:text-biharDark' :
                      obj?.title.includes("उत्तर प्रदेश") ? 'hover:text-upDark' : 'hover:text-primary'}  hover:bg-gray-100`}
                href={
                  obj?.category_detail[0]?.canonical_url ?? "#"
                }
                target="_blank"
              >
                <div className="flex justify-center items-center font-bold">
                  {`${obj?.title
                    } की सभी खबरें`}
                  <SVG
                    className="ml-2 h-4 w-4"
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.svg"
                  />
                </div>
              </a>}
            </div>
          ) : (
            <div id={index} className="scroll-margin-100">

              {obj?.title && <List2
                title={
                  `${obj?.title} की खबरें`
                }
                newsListData={obj?.content}
                isLCP={true}
                showAds={index === 0}
                haveH1={false}
              />}
              {obj?.title && <a
                className={`flex justify-center items-center h-10 w-full my-4 border rounded-md border-gray-300   ${obj?.title.includes("मध्य प्रदेश") ? 'hover:text-mpDark' : obj?.title.includes("राजस्थान") ? 'hover:text-rajasthanDark' :
                  obj?.title.includes("हरियाणा") ? 'hover:text-hrDark' : obj?.title.includes("बिहार") ? 'hover:text-biharDark' :
                    obj?.title.includes("उत्तर प्रदेश") ? 'hover:text-upDark' : 'hover:text-primary'} hover:bg-gray-100`}
                href={
                  obj?.category_detail[0]?.canonical_url ?? "#"
                }
                target="_blank"
              >
                <div className="flex justify-center items-center font-bold">
                  {`${obj?.title
                    } की सभी खबरें`}
                  <SVG
                    className="ml-2 h-4 w-4"
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.svg"
                  />
                </div>
              </a>}
            </div>
          );
        }) : <></>}

        {categoryNewsListData?.length === 0 && (
          <NoData message="No Data Found" />
        )}

        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />

        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default Category;
